import React, { useEffect, useRef } from 'react';

const imageCountdes = 3;
const imageCountmobile = 24;
const desktopImagePrefix = '/gallery/img';
const mobileImagePrefix = '/mobilegallery/img';

const Gallery = () => {
  const desktopRef = useRef(null);
  const mobileRef = useRef(null);

  const desktopImages = Array.from({ length: imageCountdes }, (_, i) => `${desktopImagePrefix}${i + 1}.jpg`);
   const mobileImages = Array.from({ length: imageCountmobile }, (_, i) => `${mobileImagePrefix}${i + 1}.jpg`);

  // Scroll logic (reusable)
  const startDesktopScroll = (ref) => {
    let scrollAmount = 0;
    const scroll = () => {
      if (!ref.current) return;

      scrollAmount += 1;
      ref.current.scrollLeft = scrollAmount;
      if (scrollAmount >= ref.current.scrollWidth - ref.current.clientWidth) {
        scrollAmount = 0;
      }

      return requestAnimationFrame(scroll);
    };

    return requestAnimationFrame(scroll);
  };

  const startMobileSlider = (ref) => {
    let index = 0;

    const interval = setInterval(() => {
      if (!ref.current) return;

      const width = ref.current.clientWidth;
      ref.current.scrollTo({
        left: index * width,
        behavior: 'smooth',
      });

      index = (index + 1) % mobileImages.length;
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  };

  useEffect(() => {
    const desktopAnimation = startDesktopScroll(desktopRef);
    const stopMobileSlider = startMobileSlider(mobileRef);

    return () => {
      cancelAnimationFrame(desktopAnimation);
      stopMobileSlider();
    };
  }, []);

  return (
    <div className="min-h-44 sm:min-h-96 p-4">
      <h1 className="text-3xl md:text-4xl text-orange-800 font-yatra text-center py-10">
        फोटो गॅलरी
      </h1>

      {/* Desktop Gallery */}
      <div
        ref={desktopRef}
        className="hidden md:flex overflow-x-auto no-scrollbar whitespace-nowrap px-2"
      >
        {desktopImages.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Desktop Gallery ${index + 1}`}
            className="h-72 w-auto object-cover"
          />
        ))}
      </div>

      {/* Mobile Gallery */}
     {/* Mobile Gallery */}
<div
  ref={mobileRef}
  className="md:hidden flex overflow-x-auto snap-x snap-mandatory no-scrollbar w-full h-[30vh]"
>
  {mobileImages.map((src, index) => (
    <div key={index} className="flex-shrink-0 w-full h-full snap-start">
      <img
        src={src}
        alt={`Mobile Gallery ${index + 1}`}
        className="w-full h-full object-cover"
      />
    </div>
  ))}
</div>

    </div>
  );
};

export default Gallery;
